<div class="mat-typography mat-body mat-app-background">
  <!-- HEADER -->
  <section class="header-info">
    <div class="header-and-zip-and-print">
      <div class="name-and-premium">
        <h1>{{ planData.productName }}</h1>
        <h2>Monthly Premium: {{ planData.price | currency }}</h2>
      </div>
      <div class="zip-and-print pull-right min-width-20">
        @if (enableNewPrintExperience) {
          <app-plan-details-pdf-print></app-plan-details-pdf-print>
        } @else {
          <app-print-button></app-print-button>
        }
      </div>
    </div>
  </section>

  <!-- CARD -->
  <section class="header-cards">
    <div class="card-container">
      <app-enroll-button
        [enrollStartUrl]="enrollStartUrl"
        [specialEnrollmentUrl]="specialEnrollmentUrl"
        [plan]="planData"
        [isSep]="isSep">
      </app-enroll-button>
    </div>

    <button mat-raised-button color="primary" [hidden]="!sendReferralUrl" (click)="goToSendReferral()">
      <span>Send Email</span>
    </button>
    
    @if (showSaveQuoteButton) {
    <div class="card-container">
      <app-save-quote-button
        [enrollmentFlow]="enrollmentFlow"
        [quoteButtonPage]="quoteButtonPage"
        [saveQuoteText]="saveQuoteText"
        [returnUrl]="returnUrl">
      </app-save-quote-button>
    </div>
    }

  </section>
</div>
